import { Box, BoxProps, Image } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import PSkeleton from './Skeleton'
import { colors } from '../theme/cssVariables'

interface FlipCardProps {
  front: React.ReactNode
  back: React.ReactNode
  containerStyle?: BoxProps
  frontStyle?: BoxProps
  backStyle?: BoxProps
  isLoaded?: boolean
}

const FlipCard: React.FC<FlipCardProps> = ({
  front,
  back,
  containerStyle,
  frontStyle,
  backStyle,
  isLoaded = true,
}) => {
  return (
    <PSkeleton
      as={motion.div}
      position="relative"
      sx={{ perspective: '1000px' }}
      _hover={{ '& .inner': { transform: 'rotateY(180deg)' } }}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      {...containerStyle}
      isLoaded={isLoaded}
    >
      {!isLoaded && (
        <Image
          visibility={'visible'}
          src={
            'data:image/png;base64,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'
          }
        />
      )}
      <Box
        className="inner"
        width="100%"
        height="100%"
        position="absolute"
        sx={{ transformStyle: 'preserve-3d' }}
        transition="transform 0.1s"
        bg={colors.colorB6}
      >
        {/* 正面 */}
        <Box
          position="absolute"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ backfaceVisibility: 'hidden' }}
          {...frontStyle}
        >
          {front}
        </Box>

        {/* 反面 */}
        <Box
          position="absolute"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          transform="rotateY(180deg)"
          sx={{ backfaceVisibility: 'hidden' }}
          {...backStyle}
        >
          {back}
        </Box>
      </Box>
    </PSkeleton>
  )
}

export default FlipCard
